<ion-header>
  <ion-toolbar color="primary">
    <ion-title i18n>Déclarer un incident CRT</ion-title>
    <ion-buttons slot="end">
      <ion-button (click)="closeModal()">
        <ion-icon name="close"></ion-icon>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>

<ion-content>
  <form [formGroup]="dysfonctionnementForm">
    <ion-item lines="none">
      <ion-label class="dys-label required" position="stacked" i18n>
        Veuillez renseigner le dysfonctionnement constaté
      </ion-label>
      <ion-textarea
        class="dys-text-input"
        [counter]="true"
        [maxlength]="maxTextLength"
        rows="6"
        formControlName="dysfonctionnementText"
      />
      <ion-note>{{ dysTextLength() }}/{{ maxTextLength }}</ion-note>
    </ion-item>
    <ion-item>
      <ion-label position="stacked" class="dys-label" i18n>Copie du dernier écran visualisé</ion-label>
      <div class="original-screenshot">
        <img (click)="openImage(originScreenshot)" [src]="'data:image/jpeg;base64, ' + originScreenshot" alt="" />
      </div>
    </ion-item>
    <ion-item lines="none">
      <ion-label position="stacked" class="dys-label" i18n>Identification du site</ion-label>
      <div class="infos-container">
        <span i18n>Menu actuel : {{ menuName }}</span>
        <span i18n>Page actuelle : {{ pageName }}</span>
        <span *ngFor="let info of contextInfos">{{ info.key }} : {{ info.value }}</span>
      </div>
    </ion-item>
  </form>
  <div class="buttons-container">
    <ion-button
      center
      full
      color="danger"
      [disabled]="dysfonctionnementForm.get('dysfonctionnementText').invalid"
      (click)="createEmail()"
      i18n
    >
      Envoyer
    </ion-button>
  </div>
</ion-content>
